import React, { useState } from 'react';
import { TIPOS, chaveDe, validarCampo } from '../lib/campos';

// Campos customizados por empresa (roadmap #24): define aqui, aparece no
// formulário, no modal, no card e na exportação, sem mexer no código.
function CamposView({ campos = [], company, companyLabel, isAdmin, onSalvar }) {
  const [edit, setEdit] = useState(null); // { key?, label, tipo, opcoes[], no_card }
  const [erro, setErro] = useState('');
  const branco = { label: '', tipo: 'texto', opcoes: [], no_card: false };

  const guardar = async () => {
    const msg = validarCampo(edit, campos);
    if (msg) { setErro(msg); return; }
    const opcoes = edit.tipo === 'selecao' ? (edit.opcoes || []).map(o => String(o).trim()).filter(Boolean) : [];
    const novo = { ...edit, label: edit.label.trim(), opcoes, key: edit.key || chaveDe(edit.label, campos.map(c => c.key)) };
    await onSalvar(edit.key ? campos.map(c => c.key === edit.key ? novo : c) : [...campos, novo]);
    setEdit(null); setErro('');
  };
  const remover = async (c) => {
    if (!confirm(`Remover o campo "${c.label}"? Os valores já preenchidos continuam gravados nos leads, mas somem das telas.`)) return;
    await onSalvar(campos.filter(x => x.key !== c.key));
  };
  const mover = async (i, d) => {
    const j = i + d; if (j < 0 || j >= campos.length) return;
    const arr = [...campos]; [arr[i], arr[j]] = [arr[j], arr[i]];
    await onSalvar(arr);
  };

  const inp = 'apple-input w-full px-3 py-2 text-sm';

  return <div className="max-w-2xl mx-auto space-y-4">
    <div className="flex items-center justify-between flex-wrap gap-2">
      <div>
        <h2 className="text-lg font-bold text-gray-800">Campos do lead · {companyLabel || company}</h2>
        <p className="text-xs text-gray-400 mt-0.5">Valem só nesta empresa. Aparecem no formulário, no modal e na exportação.</p>
      </div>
      {isAdmin && !edit && <button onClick={()=>{setEdit(branco);setErro('');}}
        className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded-full shadow-sm">+ Novo campo</button>}
    </div>

    {edit && <div className="acard rounded-2xl p-4 space-y-3">
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <label className="text-xs text-gray-500 font-medium mb-1 block">Nome do campo *</label>
          <input className={inp} autoFocus placeholder="Ex.: Número do CNPJ" value={edit.label} onChange={e=>setEdit({...edit, label:e.target.value})} />
        </div>
        <div>
          <label className="text-xs text-gray-500 font-medium mb-1 block">Tipo</label>
          <select className={inp} value={edit.tipo} onChange={e=>setEdit({...edit, tipo:e.target.value})}>
            {TIPOS.map(t=><option key={t.key} value={t.key}>{t.label}</option>)}
          </select>
        </div>
      </div>
      {edit.tipo === 'selecao' && <div>
        <label className="text-xs text-gray-500 font-medium mb-1 block">Opções, uma por linha</label>
        <textarea className={inp + ' h-24'} value={(edit.opcoes||[]).join('\n')} onChange={e=>setEdit({...edit, opcoes:e.target.value.split('\n')})} placeholder={'Pequeno\nMédio\nGrande'} />
      </div>}
      <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
        <input type="checkbox" checked={!!edit.no_card} onChange={e=>setEdit({...edit, no_card:e.target.checked})} />
        Mostrar no cartão do Kanban
      </label>
      {erro && <p className="text-xs text-red-600">{erro}</p>}
      <div className="flex justify-end gap-2">
        <button onClick={()=>{setEdit(null);setErro('');}} className="text-sm text-gray-500 px-4 py-2 rounded-full hover:bg-gray-100">Cancelar</button>
        <button onClick={guardar} className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2 rounded-full">{edit.key ? 'Salvar' : 'Criar campo'}</button>
      </div>
    </div>}

    {campos.length === 0 && !edit
      ? <div className="acard rounded-2xl p-10 text-center text-gray-400">
          <div className="text-4xl mb-2">🧩</div>
          <p className="text-sm">Nenhum campo próprio ainda.</p>
          <p className="text-xs mt-1">Use para o que só esta empresa precisa: CNPJ, tamanho da frota, número do contrato.</p>
        </div>
      : <div className="acard rounded-2xl divide-y divide-black/[0.05]">
          {campos.map((c,i)=>(
            <div key={c.key} className="flex items-center gap-3 px-4 py-3">
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-gray-800 truncate">{c.label}</div>
                <div className="t-caption-2 text-gray-400">
                  {TIPOS.find(t=>t.key===c.tipo)?.label || c.tipo}
                  {c.tipo==='selecao' && c.opcoes?.length ? ` · ${c.opcoes.length} opções` : ''}
                  {c.no_card ? ' · no cartão' : ''}
                  <span className="opacity-60"> · custom.{c.key}</span>
                </div>
              </div>
              {isAdmin && <div className="flex items-center gap-1 flex-shrink-0">
                <button aria-label="Subir"  onClick={()=>mover(i,-1)} disabled={i===0} className="w-6 h-6 rounded-full text-gray-300 hover:text-gray-600 hover:bg-gray-100 disabled:opacity-30">↑</button>
                <button aria-label="Descer" onClick={()=>mover(i, 1)} disabled={i===campos.length-1} className="w-6 h-6 rounded-full text-gray-300 hover:text-gray-600 hover:bg-gray-100 disabled:opacity-30">↓</button>
                <button aria-label="Editar" onClick={()=>{setEdit({...c, opcoes:c.opcoes||[]});setErro('');}} className="w-6 h-6 rounded-full text-gray-300 hover:text-blue-500 hover:bg-blue-50">✏️</button>
                <button aria-label="Excluir" onClick={()=>remover(c)} className="w-6 h-6 rounded-full text-gray-300 hover:text-red-500 hover:bg-red-50">🗑</button>
              </div>}
            </div>
          ))}
        </div>}
  </div>;
}

export { CamposView };
